import axios from 'axios';

let prefix = "/package"

const PackageApi = {

	getPackageList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	getPackageById(id, payload){
		return axios.get( prefix + "/get/" + id, {params: payload})
	},
	createPackage(payload){
		return axios.post( prefix + "/create", payload)
	},
	updatePackage(payload){
		return axios.post( prefix + "/update", payload)
	},
	updatePackageStatus(payload){
		return axios.post( prefix + "/update-status", payload)
	},
	approvePackage(payload){
		return axios.post( prefix + "/approve", payload)
	},
	rejectPackage(payload){
		return axios.post( prefix + "/reject", payload)
	},
	archivePackage(payload){
		return axios.delete( prefix + "/delete/" + payload.id, {params: payload})
	},
	getPackagePreview(id, payload){
		return axios.get( prefix + "/preview/" + id, {params: payload})
	},
	exportPackage(payload){
		return axios.get( prefix + "/export", {params: payload, responseType: 'blob'})
	},

	// Bulk package import — mirrors the product import endpoints.
	downloadPackageCsvTemplate(){
		return axios.get( prefix + "/download-csv-template", {responseType: 'blob'})
	},
	importPackageCsv(formData){
		return axios.post( prefix + "/import-csv", formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
	},
	getPackageBatchImportHistory(params){
		return axios.get( prefix + "/batch-import-history", {params})
	},
	getPackageBatchImportDetails(batchId, params){
		return axios.get( prefix + "/batch-import/" + batchId, {params})
	},
	updatePackageBatchImportItem(payload){
		return axios.post( prefix + "/update-failed-import", payload)
	},
	confirmPackageBatchImport(batchId){
		return axios.post( prefix + "/confirm-batch-import/" + batchId)
	},
	deletePackageBatchImport(batchId){
		return axios.delete( prefix + "/batch-import/" + batchId)
	},

	// Bulk package UPDATE. The import endpoints above only create; these only
	// change packages that already exist, and nothing is written until apply.
	exportPackagesForUpdate(params){
		return axios.get( prefix + "/export-for-update", {params, responseType: 'blob'})
	},
	uploadPackageBulkUpdate(formData){
		return axios.post( prefix + "/bulk-update/upload", formData, {
			headers: { 'Content-Type': 'multipart/form-data' }
		})
	},
	getPackageBulkUpdateDetails(batchId){
		return axios.get( prefix + "/bulk-update/" + batchId)
	},
	getPackageBulkUpdateHistory(params){
		return axios.get( prefix + "/bulk-update-history", {params})
	},
	applyPackageBulkUpdate(batchId){
		return axios.post( prefix + "/bulk-update/" + batchId + "/apply")
	},
	deletePackageBulkUpdate(batchId){
		return axios.delete( prefix + "/bulk-update/" + batchId)
	},

	// Translation methods
	getPackageTranslations(packageId) {
		return axios.get(`${prefix}/${packageId}/translations`)
	},
	getPackageTranslationByLocale(packageId, locale) {
		return axios.get(`${prefix}/${packageId}/translations/${locale}`)
	},
	savePackageTranslation(packageId, payload) {
		return axios.post(`${prefix}/${packageId}/translations`, payload)
	},
	deletePackageTranslation(packageId, locale) {
		return axios.delete(`${prefix}/${packageId}/translations/${locale}`)
	},

}

export default PackageApi;
